import { ComponentProps } from 'react';

import { Transactions } from '@/shared/assets';
import { cn } from '@/shared/lib';
import { Heading, ScreenCard } from '@/shared/ui';

export const TransactionsLastMonthInfo = ({
  className,
  ...props
}: ComponentProps<typeof ScreenCard>) => {
  return (
    <ScreenCard
      size="sm"
      className={cn(
        'mt-1 flex items-center justify-between rounded-4xl px-5 py-4 md:px-6',
        className,
      )}
      {...props}
    >
      <div className="flex flex-col gap-y-1">
        <Heading variant="xs">Transactions</Heading>
        {/* <Typography variant="14-r" color="text-base-100">
          710.61&#8239;€ Spent in August
        </Typography> */}
      </div>

      <Transactions />
    </ScreenCard>
  );
};
